import { tefApi } from '@/api/axiosInstance';
import {
  TefCancelRequest,
  TefPaymentRequest,
  TefPaymentResponse,
  TefPaymentType,
} from './tef.types';

export default {
  async payment({ type, ...data }: TefPaymentRequest) {
    const path: Record<TefPaymentType, string> = {
      debit: '/venda/debito',
      credit: '/venda/credito',
      pix: '/pix',
    };

    const result = await tefApi.post<TefPaymentResponse>(path[type], {
      valor: data.valor.toFixed(2),
      parcelas: data.parcelas?.toString(),
      financiamento: data.financiamento,
    });

    return result.data;
  },

  async activation(cnpjCpf?: string) {
    const result = await tefApi.post(`/ativacao`, {
      cnpjCpf,
    });
    return result.data;
  },

  async cancel(data: TefCancelRequest) {
    const result = await tefApi.post<TefPaymentResponse>(`/adm/cancelamento`, {
      ...data,
      valor: data.valor.toFixed(2),
    });

    return result.data;
  },
};
